import React from 'react';

import FilterMultiSelect from './FilterMultiSelect';
import { dashboardStatusOptions } from '../../utils/dashboardStatusFilter';

type StatusMultiFilterProps = {
  idPrefix: string;
  area: string;
  selected: string[];
  onChange: (next: string[]) => void;
};

const StatusMultiFilter: React.FC<StatusMultiFilterProps> = ({ idPrefix, area, selected, onChange }) => {
  const options = dashboardStatusOptions(area);

  return (
    <FilterMultiSelect id={idPrefix} options={options} selected={selected} onChange={onChange} allLabel="Todos" />
  );
};

export default StatusMultiFilter;
